import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";

import MakeAPICall from "../../apiCalls/common";
import { connect } from "react-redux";
import appRoutes from "../../routes/appRoutes";

import { getSupportStaffApiRoute, addTicketApiRoute } from "../../apiRoutes";

import Loader from "../../components/loader";
import CustomModal from "../../components/modal";
import GenerateTicketForm from "../../containers/Tickets/generateTicketForm";

const GenerateTicketPage = (props) => {
  let history = useHistory();

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [staff, setStaff] = useState([]);
  const [showSuccessModal, setToggleSuccessModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // get the staff list
  // const getSupportStaffData = useCallback(() => {
  //   setApiCallParams({
  //     reqType: "GET",
  //     reqUrl: getSupportStaffApiRoute,
  //     params: {
  //       skip: 0,
  //       limit: 0
  //     },
  //     successCallback: async res => {
  //       const staffList = [];
  //       await res.data.data.staffs.forEach(staff => {
  //         if (staff.isBlocked === false) {
  //           staffList.push({
  //             id: staff._id,
  //             name: staff.firstName + " " + staff.lastName
  //           });
  //         }
  //       });
  //       setStaff(staffList);
  //     },
  //     failureCallback: err => {}
  //   });
  // }, []);

  useEffect(() => {
    // getSupportStaffData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const successModalOkay = () => {
    setToggleSuccessModal(false);
    history.push(appRoutes.viewTickets);
  };

  const addTicketData = data => {
    setIsProcessing(true);
    setApiCallParams({
      reqType: "POST",
      reqUrl: addTicketApiRoute,
      dataObj: data,
      successCallback: async res => {
        setErrorMsg("");
        setIsProcessing(false);
        setToggleSuccessModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        //setErrorMsg(err.error);
      }
    });
  };

  return (
    <div className="view-ticket-container">
      {isProcessing && <Loader />}
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showSuccessModal}
        cancelEvent={successModalOkay}
        okayEvent={successModalOkay}
        modalBodyContent={
          <p className="text-center mb-0">Ticket Added Successfully</p>
        }
      />

      <div className={isProcessing ? "disableContainer" : ""}>
        <GenerateTicketForm
          staffList={props.supportStaff}
          addTicketData={addTicketData}
          errorMessage={errorMsg}
        />
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

const mapStateToProps = state => ({
  supportStaff: state.serverConstants.supportStaff,
});

export default connect(mapStateToProps, null)(GenerateTicketPage);
